import React, { Suspense } from 'react';

export const AfterSignupUserDetailsComponent = React.lazy(() => import('./AfterSignupUserDetails'));

export const AfterSignupUserDetails = (props) => (
  <Suspense fallback={null}>
    <AfterSignupUserDetailsComponent {...props} />
  </Suspense>
);
